export { CRUDService } from './src/crud.service';
export * from './src/crud.model';
